import React, { useState } from 'react';
import axios from 'axios';

const RegistrationForm = () => {
  const [step, setStep] = useState(1); // 1 for OTP verification, 2 for entering details
  const [otp, setOtp] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');

  const handleOTPVerification = async () => {
    try {
      const response = await axios.post('your-backend-url/verifyOTP', { mobileNo: '9812419368', otp });
      if (response.data.message === 'OTP verified successfully') {
        setStep(2); // Move to the next step
      } else {
        alert('Invalid OTP');
      }
    } catch (error) {
      console.error(error);
      alert('Server error');
    }
  };

  const handleRegistration = async () => {
    try {
      await axios.post('your-backend-url/registerUser', { name, mobileNo: '9812419368', email, gender });
      alert('User registered successfully');
    } catch (error) {
      console.error(error);
      alert('Server error');
    }
  };

  return (
    <div>
      {step === 1 && (
        <>
          <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
          <button onClick={handleOTPVerification}>Verify OTP</button>
        </>
      )}
      {step === 2 && (
        <>
          <input type="text" placeholder="Enter Name" value={name} onChange={(e) => setName(e.target.value)} />
          <input type="email" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <select value={gender} onChange={(e) => setGender(e.target.value)}>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
          <button onClick={handleRegistration}>Register</button>
        </>
      )}
    </div>
  );
};

export default RegistrationForm;
